import { bulletinSubscribe } from 'backend/bulletinSubscribe.jsw';

// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function button4_click_1(event) {
	const email = $w('#input5').value;
 
  bulletinSubscribe('3WRKdVTMsp', email).then((res) => {
    $w('#input5').value = '';
    $w('#input5').resetValidityIndication();
	  $w('#text41').expand();
    $w('#text41').text = "Thank you for subscribing"
  }, err => {
    console.error(err);
    $w('#text41').expand();
    $w('#text41').text = "Something went wrong. You may already be subscribed."
  })

	

}